import { get, post, put, remove } from './HttpService';
import {
	CreateThemeCommand,
	PaginatedListOfThemeOverviewDto,
	ThemeDetailDto,
	ThemeDto,
	UpdateThemeCommand
} from '../models/models';
import { Theme } from '../redux/themes/theme.types';
import { HttpResponse } from '../redux/http/http.types';
import { hasFailed } from '../utils';
import { dispatchSnackbar } from '../services/SnackbarService';

export async function postTheme(theme: Theme): Promise<string> {
	const command: CreateThemeCommand = {
		name: theme.name,
		licenceIds: theme.licenceIds,
		chapterId: theme.regionId ? undefined : theme.chapterId,
		regionId: theme.regionId ? theme.regionId : undefined,
		order: theme.order
	};

	const response: HttpResponse<string> = await post<
		string,
		CreateThemeCommand
	>(`theme`, `themes`, command);

	dispatchSnackbar('thema', 'POST', !hasFailed(response, true));

	return response.data!;
}

export async function getThemesByParentAndLicenceIds(
	chapterId: string | undefined,
	regionId: string | undefined,
	licenceIds: string[]
): Promise<ThemeDto[]> {
	const queryString: string = licenceIds.join('&licenceIds=');

	const parentString: string =
		chapterId !== undefined
			? `chapterId=${chapterId}`
			: regionId !== undefined
			? `regionId=${regionId}`
			: '';

	const response: HttpResponse<ThemeDto[]> = await get<ThemeDto[]>(
		`theme`,
		`themes/getByLicenceIds?${parentString}&licenceIds=${queryString}`
	);

	return response.data!;
}

export async function getThemesByChapterId(
	chapterId: string
): Promise<ThemeDto[]> {
	const response: HttpResponse<ThemeDto[]> = await get<ThemeDto[]>(
		`theme`,
		`chapters/${chapterId}/themes`
	);

	return response.data!;
}

export async function getThemesByRegionId(
	regionId: string
): Promise<ThemeDto[]> {
	const response: HttpResponse<ThemeDto[]> = await get<ThemeDto[]>(
		`theme`,
		`regions/${regionId}/themes`
	);

	return response.data!;
}

export async function getAllThemes(
	queryString: string
): Promise<PaginatedListOfThemeOverviewDto> {
	const response: HttpResponse<PaginatedListOfThemeOverviewDto> =
		await get<PaginatedListOfThemeOverviewDto>(
			'theme',
			`themes${queryString}`
		);

	return response.data!;
}

export async function getTheme(id: string): Promise<ThemeDetailDto> {
	const response: HttpResponse<ThemeDetailDto> = await get<ThemeDetailDto>(
		'theme',
		`themes/${id}`
	);

	return response.data!;
}

export async function putTheme(theme: Theme): Promise<void> {
	const command: UpdateThemeCommand = {
		id: theme.id as string,
		name: theme.name,
		licenceIds: theme.licenceIds,
		chapterId: theme.regionId ? undefined : theme.chapterId,
		regionId: theme.regionId ? theme.regionId : undefined,
		order: theme.order
	};

	const response: HttpResponse = await put<UpdateThemeCommand>(
		`theme`,
		`themes`,
		command
	);

	dispatchSnackbar('thema', 'PUT', !hasFailed(response));
}

export async function removeTheme(id: string): Promise<void> {
	const response: HttpResponse = await remove(`theme`, `themes/${id}`);

	dispatchSnackbar('thema', 'DELETE', !hasFailed(response));
}
